































































































































































































































































































import {Component, Mixins} from 'vue-property-decorator';

import TranslatedRouter from '@/mixins/TranslatedRouter';
import {TranslateResult} from 'vue-i18n';
import {gsap, Power3} from '@/utils/gsap';

@Component({})
export default class Footer extends Mixins(TranslatedRouter) {

	get absolutePath() {
		return serverVariables.httpRequest.baseUrl;
	}
	get getPdfPath() {
		return this.absolutePath + 'dist/pdf/';
	}
	get filesList(): TranslateResult {
		return this.$t('footer.files.list');

	}
	get productList(): TranslateResult {
		return this.$t('footer.product.list');

	}

	get orkaList(): TranslateResult {
		return this.$t('footer.orka.list');

	}

	get socialList(): TranslateResult {
		return this.$t('footer.socials');

	}

	get stores(): TranslateResult {
		return this.$t('footer.stores');

	}

	get conditionMenuList(): TranslateResult {
		return this.$t('footer.bottom.list');

	}

	get locale(): string {
		return this.$store.state.locale;
	}

	get currentYear(): number {
		return new Date().getFullYear();
	}

	get languageModalName(): string {
		return this.$t('routes.user.language.modalName') as string;
	}

	scrollTop(): void {
		if (typeof window === 'undefined') {
			return;
		}

		gsap.to(window, 1, {
			scrollTo: {y: 0},
			ease: Power3.easeInOut,
			delay: 0
		});
	}

	uCFirst(string: string): string {
		return `${string.charAt(0).toLocaleUpperCase()}${string.slice(1)}`;
	}

}
